import { EmailSignupService } from './email-signup.service'

/**
 * Newsletter footer signup component.
 *
 * Handles form submission for the shared newsletter signup form rendered
 * by the ``newsletter_widget/newsletter_widget.html`` template.
 *
 * Activated by the ``[data-newsletter-component]`` attribute on the wrapper element.
 */
export class NewsletterComponent {
  private form: HTMLFormElement | null = null
  private messageDiv: HTMLDivElement | null = null
  private emailInputEl: HTMLInputElement | null = null
  private csrfTokenEl: HTMLInputElement | null = null

  public constructor() {
    this.form = document.querySelector<HTMLFormElement>('#newsletterForm')
    this.messageDiv = document.querySelector<HTMLDivElement>('#newsletterMessage')

    if (!this.form || !this.messageDiv) return

    this.emailInputEl = this.form.querySelector<HTMLInputElement>('input[name="email"]') ?? null
    this.csrfTokenEl = this.form.querySelector<HTMLInputElement>('input[name="csrfmiddlewaretoken"]') ?? null

    if (!this.emailInputEl || !this.csrfTokenEl) return

    this.initEvents()
  }

  private initEvents(): void {
    this.form!.addEventListener('submit', async (e: Event) => await this.handleSubmit(e))
  }

  private async handleSubmit(e: Event): Promise<void> {
    e.preventDefault()

    const email = this.emailInputEl!.value.trim()
    const emailService = EmailSignupService.getInstance()

    // Create configuration for footer newsletter
    const config = EmailSignupService.createNewsletterConfig('footer-newsletter', 'footer')

    // Disable form elements after successful signup
    config.onSuccess = () => {
      this.form!.reset()
      Array.from(this.form!.elements).forEach((el) => {
        ;(el as HTMLInputElement | HTMLButtonElement).disabled = true
      })
    }

    const result = await emailService.submitSignup(email, config)

    this.showMessage(result.message || 'Thank you for signing up!', result.success ? 'success' : 'error')
  }

  private showMessage(message: string, type: 'success' | 'error'): void {
    if (!this.messageDiv) return

    this.messageDiv.textContent = message
    this.messageDiv.classList.remove('success', 'error')
    this.messageDiv.classList.add(type)
    this.messageDiv.style.display = 'block'
  }
}
